import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';
import webClient from '../../core/web_client';
import { buildQueryString, extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { PRODUCTS_AVAILABILITY_PATH } from '../../core/constants';

export const getProductsAvailabilityAction = createAsyncThunk(
    'reservation/getProductsAvailabilityAction',
    async (queryParams, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.get(`${ PRODUCTS_AVAILABILITY_PATH }${ buildQueryString(queryParams) }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const getProductsAvailabilitySlice = createSlice({
    name: 'getProductsAvailabilitySlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getProductsAvailabilityAction.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getProductsAvailabilityAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(getProductsAvailabilityAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const getProductsAvailabilityState = (state) => state.reservation.getProductsAvailability;
export default getProductsAvailabilitySlice.reducer;
